/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {AddDelousing} from '../bioplanModels';
// @ts-ignore
import type {AddSiteDelousing} from '../bioplanModels';
// @ts-ignore
import type {Delousing} from '../bioplanModels';
// @ts-ignore
import type {EditDelousing} from '../bioplanModels';
/**
 * PlanningDelousingApi - axios parameter creator
 * @export
 */
export const PlanningDelousingApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete delousing by its identifier
     * @param {string} delousingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    delousingsDelousingIdDelete: async (
      delousingId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'delousingId' is not null or undefined
      assertParamExists('delousingsDelousingIdDelete', 'delousingId', delousingId);
      const localVarPath = `/delousings/{delousingId}`.replace(
        `{${'delousingId'}}`,
        encodeURIComponent(String(delousingId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get delousing by its identifier
     * @param {string} delousingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    delousingsDelousingIdGet: async (
      delousingId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'delousingId' is not null or undefined
      assertParamExists('delousingsDelousingIdGet', 'delousingId', delousingId);
      const localVarPath = `/delousings/{delousingId}`.replace(
        `{${'delousingId'}}`,
        encodeURIComponent(String(delousingId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update delousing for a cage
     * @param {string} delousingId
     * @param {EditDelousing} editDelousing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    delousingsDelousingIdPut: async (
      delousingId: string,
      editDelousing: EditDelousing,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'delousingId' is not null or undefined
      assertParamExists('delousingsDelousingIdPut', 'delousingId', delousingId);
      // verify required parameter 'editDelousing' is not null or undefined
      assertParamExists('delousingsDelousingIdPut', 'editDelousing', editDelousing);
      const localVarPath = `/delousings/{delousingId}`.replace(
        `{${'delousingId'}}`,
        encodeURIComponent(String(delousingId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(editDelousing, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all delousing actions for a cage
     * @param {string} [cageId]
     * @param {string} [siteId]
     * @param {string} [planId]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    delousingsGet: async (
      cageId?: string,
      siteId?: string,
      planId?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/delousings/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (cageId !== undefined) {
        localVarQueryParameter['cageId'] = cageId;
      }

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create delousing for a cage
     * @param {AddDelousing} addDelousing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    delousingsPost: async (addDelousing: AddDelousing, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'addDelousing' is not null or undefined
      assertParamExists('delousingsPost', 'addDelousing', addDelousing);
      const localVarPath = `/delousings/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(addDelousing, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create delousings for all cages with biomass at site
     * @param {AddSiteDelousing} addSiteDelousing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    delousingsSitePost: async (
      addSiteDelousing: AddSiteDelousing,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'addSiteDelousing' is not null or undefined
      assertParamExists('delousingsSitePost', 'addSiteDelousing', addSiteDelousing);
      const localVarPath = `/delousings/site`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(addSiteDelousing, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningDelousingApi - functional programming interface
 * @export
 */
export const PlanningDelousingApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningDelousingApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Delete delousing by its identifier
     * @param {string} delousingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async delousingsDelousingIdDelete(
      delousingId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.delousingsDelousingIdDelete(delousingId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningDelousingApi.delousingsDelousingIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get delousing by its identifier
     * @param {string} delousingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async delousingsDelousingIdGet(
      delousingId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Delousing>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.delousingsDelousingIdGet(delousingId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningDelousingApi.delousingsDelousingIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update delousing for a cage
     * @param {string} delousingId
     * @param {EditDelousing} editDelousing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async delousingsDelousingIdPut(
      delousingId: string,
      editDelousing: EditDelousing,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Delousing>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.delousingsDelousingIdPut(
        delousingId,
        editDelousing,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningDelousingApi.delousingsDelousingIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all delousing actions for a cage
     * @param {string} [cageId]
     * @param {string} [siteId]
     * @param {string} [planId]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async delousingsGet(
      cageId?: string,
      siteId?: string,
      planId?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Delousing>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.delousingsGet(
        cageId,
        siteId,
        planId,
        startDate,
        endDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningDelousingApi.delousingsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create delousing for a cage
     * @param {AddDelousing} addDelousing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async delousingsPost(
      addDelousing: AddDelousing,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Delousing>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.delousingsPost(addDelousing, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningDelousingApi.delousingsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create delousings for all cages with biomass at site
     * @param {AddSiteDelousing} addSiteDelousing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async delousingsSitePost(
      addSiteDelousing: AddSiteDelousing,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Delousing>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.delousingsSitePost(addSiteDelousing, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningDelousingApi.delousingsSitePost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningDelousingApi - factory interface
 * @export
 */
export const PlanningDelousingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningDelousingApiFp(configuration);
  return {
    /**
     *
     * @summary Delete delousing by its identifier
     * @param {PlanningDelousingApiDelousingsDelousingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    delousingsDelousingIdDelete(
      requestParameters: PlanningDelousingApiDelousingsDelousingIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .delousingsDelousingIdDelete(requestParameters.delousingId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get delousing by its identifier
     * @param {PlanningDelousingApiDelousingsDelousingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    delousingsDelousingIdGet(
      requestParameters: PlanningDelousingApiDelousingsDelousingIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Delousing> {
      return localVarFp
        .delousingsDelousingIdGet(requestParameters.delousingId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update delousing for a cage
     * @param {PlanningDelousingApiDelousingsDelousingIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    delousingsDelousingIdPut(
      requestParameters: PlanningDelousingApiDelousingsDelousingIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Delousing> {
      return localVarFp
        .delousingsDelousingIdPut(requestParameters.delousingId, requestParameters.editDelousing, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all delousing actions for a cage
     * @param {PlanningDelousingApiDelousingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    delousingsGet(
      requestParameters: PlanningDelousingApiDelousingsGetRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Delousing>> {
      return localVarFp
        .delousingsGet(
          requestParameters.cageId,
          requestParameters.siteId,
          requestParameters.planId,
          requestParameters.startDate,
          requestParameters.endDate,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create delousing for a cage
     * @param {PlanningDelousingApiDelousingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    delousingsPost(
      requestParameters: PlanningDelousingApiDelousingsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Delousing> {
      return localVarFp
        .delousingsPost(requestParameters.addDelousing, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create delousings for all cages with biomass at site
     * @param {PlanningDelousingApiDelousingsSitePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    delousingsSitePost(
      requestParameters: PlanningDelousingApiDelousingsSitePostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Delousing>> {
      return localVarFp
        .delousingsSitePost(requestParameters.addSiteDelousing, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for delousingsDelousingIdDelete operation in PlanningDelousingApi.
 * @export
 * @interface PlanningDelousingApiDelousingsDelousingIdDeleteRequest
 */
export interface PlanningDelousingApiDelousingsDelousingIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningDelousingApiDelousingsDelousingIdDelete
   */
  readonly delousingId: string;
}

/**
 * Request parameters for delousingsDelousingIdGet operation in PlanningDelousingApi.
 * @export
 * @interface PlanningDelousingApiDelousingsDelousingIdGetRequest
 */
export interface PlanningDelousingApiDelousingsDelousingIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningDelousingApiDelousingsDelousingIdGet
   */
  readonly delousingId: string;
}

/**
 * Request parameters for delousingsDelousingIdPut operation in PlanningDelousingApi.
 * @export
 * @interface PlanningDelousingApiDelousingsDelousingIdPutRequest
 */
export interface PlanningDelousingApiDelousingsDelousingIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningDelousingApiDelousingsDelousingIdPut
   */
  readonly delousingId: string;

  /**
   *
   * @type {EditDelousing}
   * @memberof PlanningDelousingApiDelousingsDelousingIdPut
   */
  readonly editDelousing: EditDelousing;
}

/**
 * Request parameters for delousingsGet operation in PlanningDelousingApi.
 * @export
 * @interface PlanningDelousingApiDelousingsGetRequest
 */
export interface PlanningDelousingApiDelousingsGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningDelousingApiDelousingsGet
   */
  readonly cageId?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningDelousingApiDelousingsGet
   */
  readonly siteId?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningDelousingApiDelousingsGet
   */
  readonly planId?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningDelousingApiDelousingsGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningDelousingApiDelousingsGet
   */
  readonly endDate?: string;
}

/**
 * Request parameters for delousingsPost operation in PlanningDelousingApi.
 * @export
 * @interface PlanningDelousingApiDelousingsPostRequest
 */
export interface PlanningDelousingApiDelousingsPostRequest {
  /**
   *
   * @type {AddDelousing}
   * @memberof PlanningDelousingApiDelousingsPost
   */
  readonly addDelousing: AddDelousing;
}

/**
 * Request parameters for delousingsSitePost operation in PlanningDelousingApi.
 * @export
 * @interface PlanningDelousingApiDelousingsSitePostRequest
 */
export interface PlanningDelousingApiDelousingsSitePostRequest {
  /**
   *
   * @type {AddSiteDelousing}
   * @memberof PlanningDelousingApiDelousingsSitePost
   */
  readonly addSiteDelousing: AddSiteDelousing;
}

/**
 * PlanningDelousingApi - object-oriented interface
 * @export
 * @class PlanningDelousingApi
 * @extends {BaseAPI}
 */
export class PlanningDelousingApi extends BaseAPI {
  /**
   *
   * @summary Delete delousing by its identifier
   * @param {PlanningDelousingApiDelousingsDelousingIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningDelousingApi
   */
  public delousingsDelousingIdDelete(
    requestParameters: PlanningDelousingApiDelousingsDelousingIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningDelousingApiFp(this.configuration)
      .delousingsDelousingIdDelete(requestParameters.delousingId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get delousing by its identifier
   * @param {PlanningDelousingApiDelousingsDelousingIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningDelousingApi
   */
  public delousingsDelousingIdGet(
    requestParameters: PlanningDelousingApiDelousingsDelousingIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningDelousingApiFp(this.configuration)
      .delousingsDelousingIdGet(requestParameters.delousingId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update delousing for a cage
   * @param {PlanningDelousingApiDelousingsDelousingIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningDelousingApi
   */
  public delousingsDelousingIdPut(
    requestParameters: PlanningDelousingApiDelousingsDelousingIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningDelousingApiFp(this.configuration)
      .delousingsDelousingIdPut(requestParameters.delousingId, requestParameters.editDelousing, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all delousing actions for a cage
   * @param {PlanningDelousingApiDelousingsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningDelousingApi
   */
  public delousingsGet(
    requestParameters: PlanningDelousingApiDelousingsGetRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningDelousingApiFp(this.configuration)
      .delousingsGet(
        requestParameters.cageId,
        requestParameters.siteId,
        requestParameters.planId,
        requestParameters.startDate,
        requestParameters.endDate,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create delousing for a cage
   * @param {PlanningDelousingApiDelousingsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningDelousingApi
   */
  public delousingsPost(requestParameters: PlanningDelousingApiDelousingsPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningDelousingApiFp(this.configuration)
      .delousingsPost(requestParameters.addDelousing, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create delousings for all cages with biomass at site
   * @param {PlanningDelousingApiDelousingsSitePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningDelousingApi
   */
  public delousingsSitePost(
    requestParameters: PlanningDelousingApiDelousingsSitePostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningDelousingApiFp(this.configuration)
      .delousingsSitePost(requestParameters.addSiteDelousing, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
